import { GET_TOKENCA } from 'redux/actions';
import { IAction, ITokenCAResponse } from 'interfaces/common';
import { call, put, takeLatest } from 'redux-saga/effects';
import { Global } from 'constants/main';

const getTokenCA = () => {
  const headers = new Headers();

  headers.append('pragma', 'no-cache');
  headers.append('cache-control', 'no-cache');
  headers.append(
    'Authorization',
    `Bearer ${Global.sockets.wts?.authToken?.accessToken}`
  );

  return fetch(`/kgw/cavault/v1/ca`, {
    method: 'GET',
    headers,
  })
    .then((res) => {
      return res.json();
    })
    .catch((err) => console.error('get token ca', err));
};

function* doRegisterTokenCA(request: IAction<undefined>) {
  let responseRegisterTokenCA: ITokenCAResponse[] = [];
  try {
    responseRegisterTokenCA = yield call(getTokenCA);
    yield put({
      type: request.response?.success,
      payload: responseRegisterTokenCA || '',
    });
  } catch (err) {
    console.log('error registertokenca', err);
    yield put({
      type: request.response?.failed,
      payload: [],
    });
  }
}

export function* watchGetTokenCA() {
  yield takeLatest(GET_TOKENCA, doRegisterTokenCA);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/Account/GetTokenCA.ts